import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'cahierLiasion';

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      // Global fallback to clean up modal backdrops when a dismiss button is clicked
      document.body.addEventListener('click', (event) => {
        const target = event.target as HTMLElement;
        if (target.hasAttribute('data-bs-dismiss') || target.closest('[data-bs-dismiss="modal"]')) {
           setTimeout(() => {
             this.forceCleanupBackdrops();
           }, 400); // Wait for Bootstrap transition to finish
        }
      });

      // Global fallback to clean up modal backdrops on route changes
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.forceCleanupBackdrops();
        }
      });
    }
  }

  private forceCleanupBackdrops() {
    // Only remove backdrops if there are no legitimately open modals
    if (document.querySelectorAll('.modal.show').length === 0) {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.querySelectorAll('.modal-backdrop').forEach(b => b.remove());
    }
  }
}
